







import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config
    })
  }
})
export default class ScrollToTop extends Vue {}
